import React from 'react'
function Education() {
    return (
        <div className='container my-5'>
            <div className="row my-5 align-items-center">
                <div className='col '>
`                   <img src='media/images/education.svg' alt='Education Image' style={{ width: "80%" }} />
                </div>
                <div className='col mt-5'>
                    <h1>Free and open market education</h1>
                    <p className="text-muted">Varsity,the largest online stock market education book in the world covering everythingh from the basics to advanced trading</p>
                    <a href='#' style={{ textDecoration: "None" }}> Explore Varsity <i class="fa-solid fa-arrow-right-long"></i></a>
                    <p className="text-muted mt-3">Tradingq&A,the most active trading and investment and in market related queries</p>
                    <a href='#' style={{ textDecoration: "None" }}>TradingQ&A <i class="fa-solid fa-arrow-right-long"></i></a>
                </div>
                
            </div>
        </div>
     );
}

export default Education;